<template>
  <div v-if="task">
    <Edit2Icon
      class="dwp-w-4 dwp-h-4 dwp-cursor-pointer dwp-transition dwp-duration-200 dwp-opacity-0 group-hover:dwp-opacity-100"
      style="fill:none"
      data-cy="edit-task"
      @click.prevent="$emit('edit')"
    />
    <Schedule
      v-if="!task.done"
      position="right"
      widthClass="dwp-w-56"
      :open.sync="open.schedule"
      v-model="task.due"
      @change="$emit('schedule', $event)"
    >
      <CalendarIcon
        class="dwp-w-4 dwp-h-4 dwp-cursor-pointer dwp-transition dwp-duration-200"
        :class="open.schedule ? 'dwp-opacity-100' : 'dwp-opacity-0 group-hover:dwp-opacity-100'"
        style="fill:none"
        data-cy="schedule-task"
      />
    </Schedule>
    <TrashIcon
      class="dwp-w-4 dwp-h-4 dwp-cursor-pointer dwp-transition dwp-duration-200 dwp-opacity-0 group-hover:dwp-opacity-100"
      style="fill:none"
      data-cy="trash-task"
      @click.prevent="$emit('trash')"
    />
  </div>
</template>

<script>
import Schedule from "@/components/shared/Schedule.vue";
import { TrashIcon, Edit2Icon, CalendarIcon } from "vue-feather-icons";
import { sync } from "vuex-pathify";

export default {
  props: {
    task: Object,
  },

  data() {
    return {
      open: {
        schedule: false,
      },
    };
  },

  components: {
    TrashIcon,
    Edit2Icon,
    CalendarIcon,
    Schedule,
  },
};
</script>